import React, { useState, useEffect } from 'react'
import './submit-ticket.less'
import { setHeader } from '@/util/set-header'
import { changeBedListApi } from '@/api/bed'
import { uploadPictureApi } from '@/api/user-infomation'
import { submitRepairApi } from '@/api/repair'
import { Toast, TextareaItem, ImagePicker } from 'antd-mobile'
import Carousel, { Modal, ModalGateway } from 'react-images'
import compress from '@/util/image-compress'

function SubmitTicket({ history }: any) {
  const [types] = useState(history?.location?.state?.child)
  const [describe, setDescribe]: any = useState()
  const [checkin_info, setCheckin_info]: any = useState()
  const [brief_id, setBrief_id]: any = useState()
  const [files, setFiles]: any = useState([] as {}[])
  const [isOpen, setIsOpen]: any = useState(false)
  const [currentIndex, setCurrentIndex]: any = useState()
  const [showImgs, setShowImgs]: any = useState([] as {}[])

  useEffect(() => {
    let checkin_id = ''
    //获取床位列表
    const getCheckinName = async () => {
      Toast.loading('加载中', 0)
      const { data } = await changeBedListApi()
      Toast.hide()
      if (data.code !== 'SUCCESS') {
        Toast.info(data.msg, 1.5)
        return
      }
      data.data.forEach((item: any) => {
        if (item.checkin_id === checkin_id) {
          setCheckin_info(item)
        }
      })
    }
    //获取入住checkin_id
    window.setPaymentInfo = (argument: string) => {
      if (typeof argument === 'string') {
        checkin_id = JSON.parse(argument).checkin_id
      } else {
        checkin_id = argument['checkin_id']
      }
    }
    if (window.WebViewBridge) {
      window.WebViewBridge.userInfo('setPaymentInfo')
    } else if (window.webkit) {
      window.webkit.messageHandlers.userInfo.postMessage('setPaymentInfo')
    }

    setHeader({ title: '报修描述' })
    getCheckinName()
  }, [])
  //选择故障类型
  const typeClick = (item: any) => {
    setBrief_id(item.id)
  }
  const compressCallBack = async (resizeFile: any) => {
    let size = Math.round((resizeFile.size * 100) / (1024 * 1024)) / 100 //按MB换算
    //限制大小小于2M
    if (size < 2) {
      let formData = new FormData()
      formData.append('file_data', resizeFile)
      formData.append('type', 'user')
      Toast.loading('加载中', 0)
      const { data } = await uploadPictureApi(formData)
      Toast.hide()
      if (data.code !== 'SUCCESS') {
        Toast.info(data.msg, 2)
        return
      }
      let url: string = data.data.url
      let id: string = JSON.stringify(files.length + 1)
      let fileList = [...files, { url, id }]
      let imgList = [...showImgs, { src: url }]
      setShowImgs(imgList)
      setFiles(fileList)
    } else {
      Toast.info('文件大小超过系统规定大小', 3)
    }
  }
  //添加删除照片
  const onChange = (files: any, type: string, tt: any) => {
    if (type === 'add') {
      //图片压缩
      compress(
        files[files.length - 1].file,
        {
          compress: {
            width: 1600,
            height: 1600,
            quality: 0.5,
          },
          type: 'file',
        },
        (resizeFile: any) => {
          compressCallBack(resizeFile)
        },
      )
    } else {
      setFiles(files)
    }
  }
  //查看图片
  const onImageClick = (index: number | undefined, fs: {}[] | undefined) => {
    setCurrentIndex(index)
    // setIsOpen(true)
  }
  const toggleModal = () => {
    setIsOpen(!isOpen)
  }
  //输入描述
  const textAreaChange = (value: string | undefined) => {
    setDescribe(value)
  }
  //提交报修
  const submitClick = async () => {
    if (brief_id === null || brief_id === undefined || brief_id === '') {
      Toast.info('请选择故障描述', 2)
      return
    }
    if (!files || files.length === 0) {
      Toast.info('请上传图片', 2)
      return
    }

    Toast.loading('加载中', 0)
    const {
      bed_id,
      store_id,
      store_name,
      bed_no,
      room_no,
      room_id,
    } = checkin_info
    const param = {
      user_name: checkin_info.full_name,
      bed_id,
      img: files.map((item: any) => item.url),
      type_id: brief_id,
      store_id,
      store_name,
      bed_no,
      room_no,
      room_id,
      describe,
    }
    const { data } = await submitRepairApi(param)
    Toast.hide()
    if (data.code !== 'SUCCESS') {
      Toast.info(data.msg, 2)
      return
    }
    Toast.info('提交成功', 1)
    history.push('/repair/list')
  }

  return (
    <div className="submit-ticket">
      <div className="sub-main">
        <p className="tips font-7">正常损耗由门店承担，人为损坏照价赔偿</p>
        <div className="address">
          <span>报修地址</span>
          <span>{checkin_info?.text}</span>
        </div>
        <div className="label">故障描述</div>
        <div className="type">
          {types?.map((item: any) => (
            <span
              className={brief_id === item.id ? 'active' : ''}
              onClick={() => typeClick(item)}
              key={item.id}
            >
              {item.name}
            </span>
          ))}
        </div>
        <TextareaItem
          value={describe}
          onChange={textAreaChange}
          className="text-area"
          placeholder="添加故障具体信息"
          rows={5}
          count={150}
        />
        <div className="label">故障照片</div>
        <ImagePicker
          files={files}
          onChange={onChange}
          onImageClick={onImageClick}
          selectable={files.length < 3}
        />
      </div>
      <div className="but" onClick={submitClick}>
        提交报修
      </div>
      <ModalGateway>
        {isOpen ? (
          <Modal onClose={toggleModal} closeOnBackdropClick={true}>
            <Carousel
              views={showImgs}
              currentIndex={currentIndex}
              hideControlsWhenIdle={1000000}
            />
          </Modal>
        ) : null}
      </ModalGateway>
    </div>
  )
}

export default SubmitTicket
